import React, { createContext, useState } from 'react';

// Crear el contexto
const ReporContext = createContext();

// Crear un proveedor del contexto
export const ReporContextProvider = ({ children, currency, setCurrency }) => {
    return (
        <ReporContext.Provider value={{ currency, setCurrency }}>
            {children}
        </ReporContext.Provider>
    );
};

export default ReporContext;
